export default "__VITE_ASSET__BoN7sMA___"